import React, { useContext, useState } from "react";
import { Text, Button } from "@geist-ui/core";
import { Shield, Check } from "@geist-ui/icons";
import API_CLIENT from "../../../utility/api-client";
import { AppContext } from "../direct-router";
import { useMediaQuery } from "@mui/material";

export default function Security() {
  const [enrolled, setEnrolled] = useState(false);
  const [isActivated, setIsActivated] = useState(false);
  const [loading, setLoading] = useState(true);
  const app_context = useContext(AppContext);
  const isMobile = useMediaQuery('(max-width:900px)');

  return (
    <div style={{ width: '100%', minHeight: '100vh', background: '#fff', paddingTop: isMobile ? '100px' : '160px', paddingBottom: '100px' }}>
      <div style={{ maxWidth: '1000pt', margin: '0 auto', padding: isMobile ? '0 16px' : '0 24px' }}>
        {/* Header */}
        <div style={{ marginBottom: isMobile ? '40px' : '80px' }}>
          <Text h2 style={{ 
            margin: 0, 
            fontWeight: 900, 
            letterSpacing: '-0.04em', 
            lineHeight: 1, 
            fontSize: '48px', 
            fontFamily: '"Nunito Sans", sans-serif', 
            color: '#000' 
          }}>
            Sicherheit
          </Text>
          <Text p style={{ color: '#888', marginTop: '16px', fontSize: '18px', fontWeight: 500, fontFamily: '"Nunito Sans", sans-serif' }}>
            Schützen Sie Ihr Konto mit Zwei-Faktor-Authentifizierung.
          </Text>
        </div>

        {/* 2FA Section */}
        <div style={{ marginBottom: isMobile ? '40px' : '80px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <div style={{ background: '#F5F5F5', width: '40px', height: '40px', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Shield size={20} color="#000" />
            </div>
            <Text h3 style={{ margin: 0, fontWeight: 800, fontSize: '24px', fontFamily: '"Nunito Sans", sans-serif', letterSpacing: '-0.02em' }}>
              Zwei-Faktor-Authentifizierung
            </Text>
          </div>

          <Text p style={{ color: '#666', fontSize: '15px', lineHeight: '1.6', fontFamily: '"Nunito Sans", sans-serif', marginBottom: '32px' }}>
            Um Ihre Daten noch besser zu schützen, können Sie hier einen zweiten Faktor einrichten. Wir unterstützen alle gängigen Apps, wie Google Authenticator oder iCloud Keychain.
          </Text>

          {isActivated ? (
            <div style={{ 
              background: '#F0FDF4', 
              border: '1px solid #BBF7D0', 
              padding: '24px', 
              borderRadius: '16px', 
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <div style={{ 
                  width: '32px', 
                  height: '32px', 
                  borderRadius: '50%', 
                  background: '#22C55E', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}>
                  <Check size={18} color="#fff" />
                </div>
                <Text span style={{ fontSize: '15px', fontWeight: 700, color: '#166534', fontFamily: '"Nunito Sans", sans-serif' }}>
                  Sie haben bereits einen zweiten Faktor eingerichtet.
                </Text>
              </div>
              <Text p style={{ color: '#166534', fontSize: '14px', margin: 0, fontFamily: '"Nunito Sans", sans-serif' }}>
                Melden Sie sich gerne bei uns, falls Sie weitere Fragen haben.
              </Text>
            </div>
          ) : (
            <div>
              {!enrolled ? (
                <Button
                  auto
                  onClick={() => {
                    API_CLIENT.enrollMFA(
                      app_context.token,
                      () => setEnrolled(true),
                      (error) => console.log(error)
                    );
                  }}
                  style={{ 
                    height: '48px',
                    padding: '0 32px',
                    background: '#000', 
                    color: '#fff', 
                    borderRadius: '100px',
                    fontSize: '15px',
                    fontWeight: 800,
                    border: 'none',
                    fontFamily: '"Nunito Sans", sans-serif'
                  }}
                >
                  Aktivieren
                </Button>
              ) : (
                <div style={{ 
                  background: '#EFF6FF', 
                  border: '1px solid #BFDBFE', 
                  padding: '20px 24px', 
                  borderRadius: '16px', 
                  color: '#1E40AF', 
                  fontSize: '15px', 
                  fontWeight: 600, 
                  fontFamily: '"Nunito Sans", sans-serif' 
                }}>
                  Ihnen wurde eine Aktivierungsmail zugesandt
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
